"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./../UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Service pro tisk štítků a obálek. Generated from cz.marbes.api.dokument.v1.obalky.ObalkaService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T17:39:16Z                      #

// ##############################################################

var ObalkaApi = function () {
  function ObalkaApi() {
    (0, _classCallCheck3.default)(this, ObalkaApi);
  }

  (0, _createClass3.default)(ObalkaApi, null, [{
    key: "tiskTestovaciStranky",

    /**
     * Vrací testovací stránku.
     *
     * @param pageOffset posun tisku
     * @return testovací stránka
     */
    value: function tiskTestovaciStranky(pageOffset) {
      var uri = serverContextPath + "/api/dokumenty/v1/obalky/testovaci/stranka/stream";
      var params = {};
      return (0, _generateUrl2.default)(uri, params, true);
    }

    /**
     * Vrácí seznam nakonfigurovaných adresních štítků.
     *
     * @return seznam adresních štítků
     */

  }, {
    key: "getSablony",
    value: function getSablony() {
      var uri = serverContextPath + "/api/dokumenty/v1/obalky/sablony";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Vytiskne adresní údaje podle zadaných metadat a položek.
     *
     * @param sablonaKod jednoznačný identifikátor použité šablony
     * @param stitky štítky, které budeme tisknout
     * @param odesilatel id subjektu odesílatele - odesílatel pro tisk na obálku, při null bude odesílatel nevyplněn
     * @param meta další vlastnosti pro tisk obálek, doplňující a řídící údaje tisku, pokud bude předán {@code null} budou použity prázdné hodnoty
     * @param pageOffset nastavení posunu stránky (vyrovnání chyby podavače), při null bude posun 0 v obou směrech
     * @return Renderované štítky ve formátu PDF
     */

  }, {
    key: "tisk",
    value: function tisk(sablonaKod, stitky, odesilatel, meta, pageOffset) {
      var uri = serverContextPath + ("/api/dokumenty/v1/obalky/sablona/" + sablonaKod + "/stream");
      var params = { odesilatel: odesilatel, meta: meta, pageOffset: pageOffset };
      return (0, _generateUrl2.default)(uri, params, true);
    }

    /**
     * Vytiskne testovací štítek s umělými daty.
     *
     * @param sablonaKod kód šablony
     * @param pageOffset posun tisku
     * @return testovací štítek
     */

  }, {
    key: "zkusebniTisk",
    value: function zkusebniTisk(sablonaKod, pageOffset) {
      var uri = serverContextPath + ("/api/dokumenty/v1/obalky/testovaci/sablona/" + sablonaKod + "/stream");
      var params = { pageOffset: pageOffset };
      return (0, _generateUrl2.default)(uri, params, true);
    }

    /**
     * Najde konkrétní šablonu dle kódu.
     *
     * @param sablonaKod kód šablony
     * @return šablona
     */

  }, {
    key: "getObalkaSablonaByKod",
    value: function getObalkaSablonaByKod(sablonaKod) {
      var uri = serverContextPath + ("/api/dokumenty/v1/obalky/sablona/" + sablonaKod);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param sablonaKod jednoznačný identifikátor použité šablony
     * @return instance vyplněná dle zvolené šablony
     */

  }, {
    key: "createTiskAdresMetaDefault",
    value: function createTiskAdresMetaDefault(sablonaKod) {
      var uri = serverContextPath + ("/api/dokumenty/v1/obalky/sablona/" + sablonaKod + "/create");
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, 0, headers));
    }
  }]);
  return ObalkaApi;
}();

exports.default = ObalkaApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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